module.exports = __webpack_public_path__ + "img/HC1004-159.1b527ca5.jpg";